import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ChevronDown, Megaphone } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Badge, BATCH_ESTADOS, CreativeBody, ObservationsList, fmtDate } from './AdsCreativeParts';
import { adsApprovalsAPI } from '../lib/api';

const ClientCreative = ({ c, idx }) => (
  <div className={`rounded-xl border p-4 space-y-3 ${c.estado === 'pendiente' ? 'border-amber-300 bg-amber-50/30' : 'bg-background'}`} data-testid={`client-creative-${c.id}`}>
    <CreativeBody c={c} idx={`c-${idx}`} />
    <ObservationsList items={c.observaciones} />
    {c.estado === 'pendiente' && (
      <Link to="/client-portal/approvals" className="inline-flex items-center gap-1 text-sm font-medium text-primary hover:underline" data-testid={`client-creative-go-approvals-${c.id}`}>
        Pendiente de tu aprobación: revísalo en Aprobaciones <ArrowRight className="w-3.5 h-3.5" />
      </Link>
    )}
  </div>
);

const ClientBatch = ({ b, open: initial, onChanged }) => {
  const [open, setOpen] = useState(initial);
  return (
    <div className="rounded-lg border" data-testid={`client-batch-${b.id}`}>
      <button type="button" onClick={() => setOpen(!open)} className="w-full flex items-center gap-2 px-4 py-3 text-left">
        <ChevronDown className={`w-4 h-4 transition-transform ${open ? '' : '-rotate-90'}`} />
        <span className="font-medium flex-1">{b.nombre} <span className="text-xs text-muted-foreground font-normal">· enviada el {fmtDate(b.sent_at)}{b.pendientes ? ` · ${b.pendientes} por revisar` : ''}</span></span>
        <Badge map={BATCH_ESTADOS} value={b.estado} testId={`client-batch-status-${b.id}`} />
      </button>
      {open && <div className="px-4 pb-4 space-y-3">{b.creatives.map((c, i) => <ClientCreative key={c.id} c={c} idx={i} />)}</div>}
    </div>
  );
};

export const ClientAdsApprovals = () => {
  const [camps, setCamps] = useState(null);
  const load = useCallback(() => adsApprovalsAPI.mine().then((r) => setCamps(r.campaigns)).catch(() => setCamps([])), []);
  useEffect(() => { load(); }, [load]);
  if (!camps?.length) return null;
  const pend = camps.reduce((a, c) => a + c.batches.reduce((x, b) => x + b.pendientes, 0), 0);
  return (
    <Card data-testid="client-ads-approvals">
      <CardContent className="p-5 space-y-4">
        <div className="flex items-center justify-between">
          <p className="font-semibold text-lg flex items-center gap-2"><Megaphone className="w-5 h-5 text-primary" />Creativos de anuncios</p>
          {pend > 0 && <span className="text-sm font-medium text-amber-800 bg-amber-100 rounded-full px-3 py-1" data-testid="client-ads-pending-count">{pend} pendiente{pend !== 1 ? 's' : ''} de aprobar</span>}
        </div>
        {camps.map((c) => (
          <div key={c.id} className="space-y-2" data-testid={`client-campaign-${c.id}`}>
            <p className="text-sm"><span className="font-semibold">Campaña: {c.nombre}</span>{c.objetivo && <span className="text-muted-foreground"> · {c.objetivo}</span>}</p>
            {c.batches.map((b, i) => <ClientBatch key={b.id} b={b} open={b.pendientes > 0 || (i === 0 && !pend)} onChanged={load} />)}
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
